"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementById = void 0;
/**
 * IDからHTML要素を取得
 * @param id HTML要素のID
 * @returns
 */
var getElementById = function (id) {
    var element = document.getElementById(id);
    if (!element) {
        throw new Error("Element with id ".concat(id, " not found"));
    }
    return element;
};
exports.getElementById = getElementById;
